module.exports = __webpack_public_path__ + "img/phone-findmykit-banner.2af5e57b.png";